import { Flex, Space, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'

import { BankLogo } from '@features/bankAccounts/elements/ConnectBankContent/elements/BankLogo'
import { isBankKontist } from '@features/bankAccounts/utils/isBankKontist'
import { isBankShine } from '@features/shineBanking/utils/isBankShine'

import { LogoKontist, LogoShineText } from '../../../../../../../../../../assets/images'

interface BankAccountTitleProps {
  bankName: string
  bankLogo?: string
}

export const BankAccountTitle = ({ bankName, bankLogo }: BankAccountTitleProps): ReactElement => {
  if (isBankShine(bankName)) {
    return (
      <>
        <LogoShineText />
        <Space size="s2" />
      </>
    )
  }

  if (isBankKontist(bankName)) {
    return (
      <>
        <LogoKontist height="30px" width="80px" />
        <Space size="s2" />
      </>
    )
  }

  return (
    <Flex alignItems="center" gap={Spacing.S8}>
      <BankLogo name={bankName} logoUrl={bankLogo} size="small" />
      <Text>{bankName}</Text>
    </Flex>
  )
}
